import {ActionTypes} from '../contants/actions-types'


const produits = []
const produit = {}
const categProduits = [];
const initialstate = {
    produitsCard: [],
}


export const productReducers = (state = produits, action) => {
    switch(action.type){
        case ActionTypes.SET_PRODUCTS : {
            return {
                ...state,
                produits: action.payload,
                // refre: action.refre,
            }
        }
        // case ActionTypes.ADD_PRODUCT : {
        //     return {
        //         ...state,
        //         produits: [...state.produits, action.payload]
        //     }
        // }
        default:
            return state;
    }
}

export const selectProductReducers = (state = produit, action) => {
    switch(action.type) {
        case ActionTypes.SELECT_PRODUCT : {
            return {
                ...state,
                produit: action.payload,
            }
        }
        default:
            return state;
    }
}

export const addtoCardReducers = (state = initialstate, action) => {
    switch(action.type) {
        case ActionTypes.ADD_TO_CARD : {
            const existItem = state.produitsCard.find(x => x.id === action.payload.id)
            if(existItem) {
                return{
                    ...state,
                    produitsCard: state.produitsCard.map(x => 
                        x.id === existItem.id ? action.payload : x),
                }
            } else {
                return {
                    ...state,
                    produitsCard: [action.payload, ...state.produitsCard],
                }
            }
            
        }
        case ActionTypes.DELETE_IN_CARD : {
            return {
                ...state,
                produitsCard: state.produitsCard.filter((item) => item.id !== action.payload),
            }
        }
        case ActionTypes.DELETE_ALL_CARD : {
            return {
                ...state,
                produitsCard: [],
            }
        }

        default:
            return state;
    }
}
// export const addtoCardReducers = (state = initialstate, action) => {
//     switch (action.type) {
//       case ActionTypes.ADD_TO_CARD:
//         return {
//             ...state,
//             produitsCard: state.produitsCard.map(product =>
//               product.id === action.payload ? {...product, selected: true} : product,
//             ),
//           };
//       case ActionTypes.DELETE_IN_CARD:
//         return {
//           ...state,
//           produitsCard: state.produitsCard.map(product =>
//             product.id === action.payload
//               ? {...product, selected: false, quantity: 1}
//               : action.payload,
//           ),
//         };
//         default:
//              return state;
//         }
// }

export const setCategProductReducers = (state = categProduits, action) => {
    switch(action.type) {
        case ActionTypes.SET_CATEG_PRODUCTS : {
            return {
                ...state,
                categProduits: action.payload,
            }
        }
        case ActionTypes.REMOVE_SELECTED_PRODUCT : {
             return {
                 ...state,
                categProduits: []
             };
        }
        default:
            return state;
    }
}

// const Cart = [];

// export const handleCart = (state = Cart, action) => {
//     const product = action.payload;
//     switch(action.type) {
//         case ActionTypes.ADD_TO_CARD:

//             const exist = state.find((x) => x.id === product.id);
//             if(exist) {
//                 return state.map((x) =>
//                 x.id === product.id ? {...x, qty: x.qty + 1} : x);
//             } else {
//                 const product = action.payload;
//                 return [
//                     ...state,
//                     {
//                         ...product,
//                         qty: 1
//                     }
//                 ]
//             }
//             break;

//             case ActionTypes.DELETE_IN_CARD:
//                 const exist1 = state.find((x) => x.id === product.id);

//                 if(exist1.qty === 1){
//                     return state.filter((x) => x.id !== exist1.id);
//                 } else {
//                     return state.map((x) =>
//                        x.id === product.id ? {...x, qty: x.qty-1} : x
//                     );
//                 }
//             break;


//             default:
//         return state;
//     }
// }